/**
 *
 * App - Main Class
 * ---
 *
 */

// SVG Definitions polyfill
svg4everybody();

// Init lazyloading
var bLazy = new Blazy();

objectFitImages();
